import SearchInput from '@shared/components/SearchInput';
import { StatusDropdown } from '@shared/components/StatusDropdown';
import { PROJECT_SEARCH_MAX_LENGTH, PROJECT_STATUSES } from '../constants';
import type { EProjectStatus } from '../types';
import ProjectStatusIcon from './ProjectStatusIcon';

type TProps = {
  search: string;
  statuses: EProjectStatus[];
  onSearchChange: (search: string) => void;
  onStatusesChange: (statuses: string[]) => void;
};
const ProjectsFilters = ({ search, statuses, onSearchChange, onStatusesChange }: TProps) => (
  <div className="flex items-center gap-3 flex-wrap">
    <SearchInput
      placeholder="Name..."
      value={search}
      maxLength={PROJECT_SEARCH_MAX_LENGTH}
      onChange={onSearchChange}
      className="flex-1 min-w-56 max-w-96"
    />
    <StatusDropdown
      multiselect
      options={PROJECT_STATUSES.map((option) => ({
        value: option.value,
        label: option.label,
        icon: <ProjectStatusIcon status={option.value} size="medium" />,
      }))}
      selectedOptions={statuses}
      onSelect={onStatusesChange}
      placeholder="All statuses"
      className="w-64"
    />
  </div>
);
export default ProjectsFilters;
